import React, { Component, Fragment } from 'react';
import './DeCultureleLadekast.Module.scss';
import 'react-tippy/dist/tippy.css';

import {
    Tooltip,
  } from 'react-tippy';

class DeCultureleLadekast extends Component {

    render() {
        
        let active = this.props.lesson.culturele_ladekast;

        if(!active || active == 'null') {
            active = [];
        }


        return (
        <Fragment>
            {/* <h4>De culturele ladekast</h4> */}
            <div styleName='grid'>
                <div styleName='grid-heading'>Receptief vermogen</div>
                <Tooltip
                // options
                title='De leerling herkent beeldend werk afkomstig uit verschillende stijlen en culturen, en kan het verschil onderscheiden'  
                position='top'
                arrow='true'
                size='small'
                >
                <div styleName={`grid-item ${active.includes('RP1') ? 'active' : ''}`}>RP1</div>
                </Tooltip>
                <Tooltip
                // options
                title='De leerling geeft betekenis aan het kunstwerk en legt een relatie met vorm, functie en doelgroep'  
                position='top'
                arrow='true'
                size='small'
                >
                <div styleName={`grid-item ${active.includes('RP2') ? 'active' : ''}`}>RP2</div>
                </Tooltip>
                <div styleName={`grid-item ${active.includes('RP3') ? 'active' : ''}`}>RP3</div>
                <div styleName={`grid-item ${active.includes('RP4') ? 'active' : ''}`}>RP4</div>
                <div styleName={`grid-item ${active.includes('RP1A') ? 'active' : ''}`}>RP1A</div>
                <div styleName={`grid-item ${active.includes('RP1B') ? 'active' : ''}`}>RP1B</div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Creerend vermogen</div>
                <div styleName={`grid-item ${active.includes('CV1') ? 'active' : ''}`}>CV1</div>
                <div styleName={`grid-item ${active.includes('CV2') ? 'active' : ''}`}>CV2</div>
                <div styleName={`grid-item ${active.includes('CV3') ? 'active' : ''}`}>CV3</div>
                <div styleName={`grid-item ${active.includes('CV4') ? 'active' : ''}`}>CV4</div>
                <div styleName={`grid-item ${active.includes('CV5') ? 'active' : ''}`}>CV5</div>
                <div styleName={`grid-item ${active.includes('CV6') ? 'active' : ''}`}>CV6</div>
                <div styleName={`grid-item ${active.includes('CV7') ? 'active' : ''}`}>CV7</div>
                <div styleName={`grid-item ${active.includes('CV1A') ? 'active' : ''}`}>CV1AA</div>
                <div styleName={`grid-item ${active.includes('CV2A') ? 'active' : ''}`}>CV2A</div>
                <div styleName={`grid-item ${active.includes('CV3A') ? 'active' : ''}`}>CV3A</div>
                <div styleName={`grid-item ${active.includes('CV4A') ? 'active' : ''}`}>CV4A</div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Reflectief vermogen</div>
                <div styleName={`grid-item ${active.includes('RF1') ? 'active' : ''}`}>RF1</div>
                <div styleName={`grid-item ${active.includes('RF2') ? 'active' : ''}`}>RF2</div>
                <div styleName={`grid-item ${active.includes('RF3') ? 'active' : ''}`}>RF3</div>
                <div styleName={`grid-item ${active.includes('RF4') ? 'active' : ''}`}>RF4</div>
                <div styleName={`grid-item ${active.includes('RF5') ? 'active' : ''}`}>RF5</div>
                <div styleName={`grid-item ${active.includes('RF1A') ? 'active' : ''}`}>RF1A</div>
                <div styleName={`grid-item ${active.includes('RF2A') ? 'active' : ''}`}>RF2A</div>
                <div styleName={`grid-item ${active.includes('RF3A') ? 'active' : ''}`}>RF3A</div>
                <div styleName={`grid-item ${active.includes('RF4A') ? 'active' : ''}`}>RF4A</div>
                <div styleName={`grid-item ${active.includes('RF5A') ? 'active' : ''}`}>RF5A</div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Analyserend vermogen</div>
                <div styleName={`grid-item ${active.includes('AV1') ? 'active' : ''}`}>AV1</div>
                <div styleName={`grid-item ${active.includes('AV2') ? 'active' : ''}`}>AV2</div>
                <div styleName={`grid-item ${active.includes('AV3') ? 'active' : ''}`}>AV3</div>
                <div styleName={`grid-item ${active.includes('AV4') ? 'active' : ''}`}>AV4</div>
                <div styleName={`grid-item ${active.includes('AV1A') ? 'active' : ''}`}>AV1A</div>
                <div styleName={`grid-item ${active.includes('AV2A') ? 'active' : ''}`}>AV2A</div>
                <div styleName={`grid-item ${active.includes('AV3A') ? 'active' : ''}`}>AV3A</div>
                <div styleName={`grid-item ${active.includes('AV4A') ? 'active' : ''}`}>AV4A</div>
                <div styleName={`grid-item ${active.includes('AV5A') ? 'active' : ''}`}>AV5A</div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
            </div>
        </Fragment>
        );
    }
}

export default DeCultureleLadekast;